import { useMemo } from 'react';

import { useAuthContext } from 'src/auth/hooks';
import useAchievements from 'src/contexts/useAchievements';

export default function useGameService(context) {
  const { user } = useAuthContext();

  const points = useMemo(() => user?.points || 0, [user]);
  const achievements = useAchievements(user?.uid);

  return { points, achievements };
}
